export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    set: {
        own: 'Own',
        prevowned: 'Previously Owned',
        fortrade: 'For Trade',
        want: 'Want',
        wanttoplay: 'Want to Play',
        wanttobuy: 'Want to Buy',
        wishlist: 'Wishlist',
        preordered: 'Pre-ordered',
        hasparts: 'Has Parts',
        wantparts: 'Wants Parts'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Collection Status',
        category: ['User', 'Collection'],
        description: 'The status of the game in a collection.',
        summarise: {
            prefix: 'Collection status'
        },
        unit: 'status'
    },
    rules: {
        linked: [],
        legacy: ['status.user','status.game','status.own','status.prevowned','status.fortrade','status.want','status.wishlist','status.hasparts','status.wantparts','stats.wanttoplay','status.wanttobuy','status.preordered']
    }
}